import {getCookie} from "../utils/cookie";
import {ShowContentDialog} from "./content-dialog";
import {expressQuerySelector} from "../common/html";
import {IPopup} from "./popup-new";
import {checkAccountValidityAsync} from "../services/account-service";

export interface ILoginWatcher {
	readonly start: (force?: boolean) => void;
	readonly cancel: () => void;
	readonly stop: () => void;
}

export function createLoginWatcher() {
	const emptyGuid = '00000000-0000-0000-0000-000000000000';
	let timer = -1;
	let startingAccId;
	let accountType;
	let dialog: IPopup;
	let openDialog = false;

	const start = (force?: boolean) => {
		if (timer < 0 || force) {
			if (force) openDialog = false;
			startingAccId = getCookie("accid");
			if (startingAccId === '') return;
			accountType = getCookie("acctype");

			// @ts-ignore
			timer = setInterval(() => { run(); }, 1500);
		}
	};

	const run = () => {
		const currentAccountId = getCookie("accid");
		if (currentAccountId === startingAccId || openDialog) return; // return nothing to report

		// User logged out in another tab
		if (!currentAccountId || currentAccountId === emptyGuid) {
			alert('Label.LoginManager.LogoutInDifferentTab', 'Label.LoginManager.LogoutInDifferentTab.PopupTitle');
			clearTimeout(timer);
			return;
		}

		// User is logged in with a different account.
		if (accountType === 'full') {
			// We used to be a FULL, now a different account -> Impossible
			alert('Label.LoginManager.DifferentAccount', 'Label.LoginManager.DifferentAccount.PopupTitle');
			clearTimeout(timer);
			return;
		}

		// TEMP got merged into FULL -> OK
		// Different FULL -> NOK
		// We need a webservice call for this ...
		openDialog = true; // set this in case that the api call takes longer then the interval and it does it again
		checkAccountValidityAsync(startingAccId, currentAccountId).then(res => {
			openDialog = false;
			if (!res.isValid) {
				alert('Label.LoginManager.DifferentAccount', 'Label.LoginManager.DifferentAccount.PopupTitle');
				return;
			}

			startingAccId = currentAccountId;
		});
	};

	const alert = (key: string, title: string) => {
		if (openDialog) return;
		openDialog = true;
		const dialogEl = expressQuerySelector<HTMLElement>(document, '.has-open-dialog', false);
		if (dialogEl && dialog)
			dialog.close();

		const onOpen = (popupEl: HTMLElement) => {
			const okButton = expressQuerySelector<HTMLElement>(popupEl, '.technical-general-popup-ok-button', false);
			if (okButton) okButton.addEventListener('click', closeEventPopup);
		};

		ShowContentDialog({ 
			dialogId: "information",
			label: key,
			title: title,
			extraPopupCss: 'p-default',
			addTitleCssClass: false,
			okButtonKey: 'Label.OkButtonText',
			openFunction: onOpen,
			onClose : () => location.reload()
		}).then(popup => {
			dialog = popup;
		});
	};

	const closeEventPopup = () => {
		location.reload();
		openDialog = false;
		dialog.close();
	};

	const cancel = () => {
		openDialog = true; // so that it does not open while we try to cancel
		clearTimeout(timer);
	};

	const stop = () => {
		if (timer < 0)
			clearTimeout(timer);
	};

	return {
		start,
		cancel,
		stop
	} as ILoginWatcher;
}
